import Policy from "./abstracts/Policy";
import { ForumCategoryModel } from "@/models";
import { auth } from "@/services";

export interface iForumCategoryPolicy {
  canDelete(forumCategory?: ForumCategoryModel): boolean;
  canManage(forumCategory?: ForumCategoryModel): boolean;
}

export class ForumCategory extends Policy implements iForumCategoryPolicy {
  /**
   * Whether the user can delete a forum category.
   *
   * @param {ForumCategoryModel=} forumCategory
   * @returns {boolean}
   */
  public canDelete(forumCategory?: ForumCategoryModel): boolean {
    const user = this.authService.user();

    if (!user) {
      return false;
    }

    return this.authService.hasPermission("forum-categories.manage");
  }

  /**
   * Whether the user can manage forum categories.
   *
   * @param {ForumCategoryModel=} forumCategory
   * @returns {boolean}
   */
  public canManage(forumCategory?: ForumCategoryModel): boolean {
    if (!this.authService.user()) {
      return false;
    }

    return this.authService.hasPermission("forum-categories.manage");
  }
}

export default new ForumCategory(auth);
